<template>
  <div class="relative z-[9999]">
    <!-- Toggle Button -->
    <button @click="showSheet = !showSheet" class="fixed text-white top-[18px] right-4 z-50">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
        <path :d="showSheet ? mdiMenuOpen : mdiMenu" />
      </svg>
    </button>

    <!-- Black Screen Overlay -->
    <div
      v-if="showSheet"
      class="fixed inset-0 z-30 transition-opacity duration-300 ease-in-out bg-black bg-opacity-80 top-[60px]"
      @click="showSheet = false"
    ></div>

    <!-- Animated Sheet -->
    <div
      class="fixed left-[-293px] z-40 w-[293px] h-full p-4 transition-transform duration-500 bg-white shadow-lg top-[60px] flex flex-col pb-16"
      :class="showSheet ? 'translate-x-[293px]' : 'translate-x-0'"
    >
      <div class="relative h-full">
        <div class="grid gap-y-3 mt-2 px-2 max-w-[260px]">
          <!-- storeFinder UButton -->
          <UButton
            to="/storefinder"
            variant="link"
            class="group w-full h-[36px] text-[14px] text-white bg-[#BE89F7] rounded-md pl-4 pr-2 flex items-center"
            style="text-decoration: none"
          >
            <span class="-mt-[1px] group-hover:underline">{{ t('storeFinder') }}</span>
          </UButton>

          <!-- truRatingHome UButton -->
          <UButton
            to="https://trurating.com/for-shoppers/"
            target="_blank"
            rel="noopener noreferrer"
            variant="link"
            class="group w-full h-[36px] text-[14px] text-black rounded-md bg-trublue-100 pl-4 pr-2 flex items-center"
            style="text-decoration: none"
          >
            <div class="flex items-center justify-between w-full">
              <div class="no-underline -mt-[1px] group-hover:underline">
                {{ t('truRatingHome') }}
              </div>
              <div class="flex items-center">
                <Icon
                  name="mdi:chevron-right"
                  class="!text-2xl text-blue-700"
                />
              </div>
            </div>
          </UButton>
        </div>
      </div>

      <div class="mt-auto">
        <img src="~/assets/images/man_woman_heart_balloon.svg" alt="Man woman heart balloon" class="mb-[20px] ml-[8px] size-32" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { mdiMenuOpen, mdiMenu } from '@mdi/js'
const { t } = useI18n()
const showSheet = ref(false)
</script>
